export default __webpack_public_path__ + "static/media/eye-off.481ee040.svg";